import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class ResolutionOrdersService {


  baseURL = environment.baseAPIURL;
  constructor( private readonly http  : HttpClient) { }

  getCountOrders(resolutionId) {
		return this.http.get(`${this.baseURL}/aetHistory/countOrders/${resolutionId}`,
			{ responseType: 'json' })
			.pipe(catchError(this.handleError));
	}
  getResolutionOrders(resolutionId){

   return this.http.get(`${this.baseURL}/aetHistory/getResolutionsOrdersTable/${resolutionId}`,  { responseType: 'json' }
   )
   .pipe(catchError(this.handleError));
 }
 
 getAllCanadaCode(){
  return this.http.get(`${this.baseURL}/aetHistory/getAllCanadaCode`, { responseType: 'json' })
    .pipe(catchError(this.handleError));
}

 private handleError(error: HttpErrorResponse) {
  return throwError(error.message || "Server Error");
}
}

